import { storiesReachRateConfig } from '@/lib/analytics/kpis/instagram/stories/storiesReachRate';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const storiesReachRateMVConfig = {
    ...storiesReachRateConfig,
    name: 'kpi.instagram.stories.stories_reach_rate',
    id: 'reach_rate',
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
